export default {"src":"/_next/static/media/privacy-by-design.3b09bfa7.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};